import { render, staticRenderFns } from "./CreatePfType.vue?vue&type=template&id=081e6580"
import script from "./CreatePfType.vue?vue&type=script&lang=js"
export * from "./CreatePfType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports